import React from 'react';
import { Link } from '@reach/router';

const NoAvailableMembers = () => (
  <>
    <div className="pa3" data-testid="no-available-members">
      <h1 className="tc display f4 fw8 tc">No available members</h1>
      <p className="tc f6 lh-copy">
        Before you can add a contributor to this group you need to add members to your space.
      </p>
    </div>
    <div className="flex bt b--light-gray">
      <Link className="flex-auto pa3 blue hover-navy tc f6" to="/notebook/settings">
        Visit Space Settings
      </Link>
    </div>
  </>
);

export default NoAvailableMembers;
